import React from "react";
import { createGlobalStyle } from "styled-components";
import { apiCall_domainV2 } from "../../api";

import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import {  Snackbar } from "@mui/material";

export class ReacordLottary extends React.Component {
  state = {
    count: "",
    totalChance: 0,
    msg: null,
    forceUpdate: false,
    open: false,
  };

  constructor() {
    super();
    this.validator = new SimpleReactValidator({
      className: "error",
      messages: {
        required: "این فیلد الزامی است",
      },
    });
  }
  forceUpdate = () => {
    this.setState({ forceUpdate: !this.state.forceUpdate });
  };
  countHandler = (e) => {
    this.setState({
      count: e,
      totalChance: e * this.props.data.required_points,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  checkForNumric = (value) => {
    if (
      value * this.props.data.required_points <= this.props.current_points &&
      value <= this.props.maximum_chance
    ) {
      this.countHandler(value);
      this.forceUpdate();
    }
  };

  submitHandler = () => {
    this.validator.showMessages();
    this.forceUpdate();
    if (this.validator.allValid()) {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .post(
          `${apiCall_domainV2}/customer/market/lottery/register`,
          { count: this.state.count, lottery_id: this.props.data.id },
          {
            headers,
          }
        )
        .then((res) => {
          this.setState({ open: true });
        })
        .catch((err) => {
          this.setState({ msg: err.response.message });
        });
    } else {
      this.validator.showMessages();
    }
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #262626;
    }`;

    return (
      <div className="reacordLottary">
        <GlobalStyles />

        {this.props.data && (
          <div>
            <div>
              <div className="reacordLottaryHeader">
                <span>ثبت شانس</span>
                <img
                  src="/public/assets/icons/Vector.svg"
                  onClick={this.props.increaceLuckHandler}
                  alt="close"
                />
              </div>
              <div className="scores">
                <span>کل امتیازات شما</span>
                <div>
                  <span>{this.props.data.customer_details?.points}</span>
                  <span>امتیاز</span>
                </div>
              </div>
              <div className="scores">
                <span> تعداد شانس ها</span>
                <div>
                  <span>{this.props.data.customer_details.chances_count}</span>
                </div>
              </div>
              <div className="lottaryDeadLine">
                <span>
                  پایان قرعه کشی
                  <span>{this.props.data.jalali_expire_time}</span>
                </span>
              </div>
              <div>
                <img src="/public/assets/coin.svg" alt="coin" />
                <span>
                  به ازای {this.props.data.required_points} امتیاز میتوانید در
                  این قرعه کشی شرکت فرمایید
                </span>
              </div>
            </div>
            <div className="neededScore">
              <span>تعداد شانس</span>
              <div>
                <span>امتیاز مورد نیاز</span>

                <div className="scorecalc">
                  <input
                    inputMode="numeric"
                    type="text"
                    value={this.state.count}
                    onChange={(e) => this.checkForNumric(e.target.value)}
                    name="chance"
                  />
                  <span>
                    <img src="/public/assets/icons/Vector.svg" alt="close" />
                  </span>
                  <span>
                    <img src="/public/assets/coin.svg" alt="coin" />
                    <span>{this.props.data.required_points}</span>
                  </span>
                  <span>=</span>
                  <span>{this.state.totalChance}</span>
                  <img src="/public/assets/coin.svg" alt="coin" />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="chanceBtnSection">
          {this.validator.message("chance", this.state.count, "required")}
          <button className="chanceBtn" onClick={() => this.submitHandler()}>
            دریافت شانس
          </button>
        </div>
        <Snackbar
          open={this.state.open}
          autoHideDuration={100}
          onClose={this.handleClose}
          message="با موفقیت شانس شما ثبت شد"
        />
      </div>
    );
  }
}
